import { UserManager, Log, WebStorageStateStore } from 'oidc-client';
import userStore from './UserStore';

let userManager: UserManager | null = null;

export function getUserManager(): UserManager {
    if (!userManager) {
        let { acfg } = window.appConfig;

        let userManagerConfig = {
            authority: acfg.authority,
            client_id: acfg.clientId,
            redirect_uri: acfg.redirectUri,
            post_logout_redirect_uri: acfg.postLogoutRedirectUri,
            silent_redirect_uri: acfg.silentRedirectUri,
            response_type: 'code',
            scope: acfg.scope,
            filterProtocolClaims: true,
            clockSkew: 600,
            loadUserInfo: true,
            revokeAccessTokenOnSignout: true,
            userStore: new WebStorageStateStore({ store: window.sessionStorage })
        };

        userManager = new UserManager(userManagerConfig);

        userManager.events.addSilentRenewError(() => {
            // eslint-disable-next-line
            console.warn('silent renew failed');
        });

        userManager.events.addAccessTokenExpired(() => {
            // eslint-disable-next-line
            //console.warn('access token expired');
        });

        userManager.events.addUserUnloaded(async () => {
            //console.log("remove user from storage");
            userStore.removeUserFromStorage();
        });

        userManager.events.addUserSignedOut(async () => {
            //await userManager.removeUser();
            //await userManager.signinRedirect();
        });

        Log.logger = console;
        Log.level = Log.ERROR;
    }

    return userManager;
}
